/**
 * This service is used during app bootstrap in production-app.js and develop-app.js
 * Hence, it shouldn't use apiClientService, because it uses configService which is
 * not already loaded during that bootstrapping.
 */
export const pageDataService = {
  getPageDataPath: path => {
    let pagePath = path.toLowerCase().replace(/index.html$/, '');
    pagePath = pagePath === '/' || pagePath === '' ? 'index' : path;
    return `/page-data/${pagePath}/page-data.json`.replaceAll(/\/{2,}/g, '/');
  },

  getPageData: async path => {
    const pageData = await fetch(pageDataService.getPageDataPath(path)).then(
      response => response.json()
    );
    return pageData;
  },
  getPageDataContent: async path => {
    const pageData = await pageDataService.getPageData(path);
    // TODO: remove null short circuit so it defaults to undefined. Check Transporter before doing it.
    return pageData?.result?.pageContext?.node?.data?.content || null;
  }
};
